import React, { useCallback, useContext, useEffect, useState} from "react";
import { node } from "prop-types";
import LOCAL_STORAGE_KEY from "../../../service/local-storage/constant";
import { THEME_KEY } from "../../theme-toggler/constant";

const ThemeContext = React.createContext({});

const propTypes = {
    children: node.isRequired
};

function ThemeContextProvider(props) {
    const { children } = props;
    const lsKey = localStorage.getItem(LOCAL_STORAGE_KEY.THEME_KEY);
    const [theme, setTheme] = useState(lsKey);

    useEffect(() => {
        if (!theme) {
            localStorage.setItem(LOCAL_STORAGE_KEY.THEME_KEY, THEME_KEY.DARK);
            setTheme(THEME_KEY.DARK);

            document.body.dataset.theme = THEME_KEY.DARK;
        } else {
            document.body.dataset.theme = theme;
        }
    }, [theme]);

    const themeToggle = useCallback(() => {
        setTheme((prevState) => {
            const nextState = prevState === THEME_KEY.LIGHT ? THEME_KEY.DARK : THEME_KEY.LIGHT;

            localStorage.setItem(LOCAL_STORAGE_KEY.THEME_KEY, nextState);

            return nextState;
        })
    }, []);

    return (
        <ThemeContext.Provider value={{ theme, setTheme: themeToggle }}>
            {children}
        </ThemeContext.Provider>
    );
}

ThemeContextProvider.propTypes = propTypes;

export function useDarkMode() {
    const { theme } = useContext(ThemeContext);
    return theme === THEME_KEY.DARK;
}

export { ThemeContext, ThemeContextProvider };
